import BenefitsOfMemoryFoam from "../../components/pages/blog/benefits-of-memory-foam";

export default BenefitsOfMemoryFoam;
